<template>
	<div class="layout layout--small mb-" :class="extraCssClass">
		<div class="layout__item u-1/2">
			<label for="postalcode">Postcode</label>
			<input
				type="text"
				id="postalcode"
				v-mask="['#### AA']"
				name="postalcode"
				autocomplete="postal-code"
				v-model="address.Postalcode"
				@keyup="checkPostalCode()"
				@change="$emit('address-changed', address)"
			/>
		</div>
		<div class="layout__item u-1/2">
			<div class="layout layout--flush o-input-combined">
				<div class="layout__item u-1/2">
					<label for="housenumber">Huisnr</label>
					<input
						type="text"
						id="housenumber"
						name="housenumber"
						autocomplete="off"
						maxlength="5"
						ref="houseNumberInput"
						v-model="address.HouseNumber"
						@change="$emit('address-changed', address)"
					/>
				</div>
				<div class="layout__item u-1/2 o-input-combined--split">
					<label for="housenumberAddition">Toev.</label>
					<input
						type="text"
						id="housenumberAddition"
						name="housenumberAddition"
						autocomplete="off"
						v-model="address.HouseNumberAddition"
						@change="$emit('address-changed', address)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mask } from 'vue-the-mask';
export default {
	directives: { mask },
	props: {
		extraCssClass: String,

		resolvedAddress: {
			type: Object,
			default: () => {},
		},
		address: {
			type: Object,
			default: () => {
				return {
					Postalcode: '',
					HouseNumber: null,
					HouseNumberAddition: null,
				};
			},
		},
	},
	computed: {
		formattedAddress: function () {
			if (this.resolvedAddress && this.resolvedAddress.Street) {
				let returnString = this.resolvedAddress.Street + ' ' + this.address.HouseNumber;
				if (this.resolvedAddress.HouseNumberAddition) {
					returnString += this.address.HouseNumberAddition;
				}
				return returnString;
			} else {
				return '';
			}
		},
		formattedCity: function () {
			if (this.resolvedAddress && this.resolvedAddress.City) {
				return (
					this.resolvedAddress.City.substr(0, 1).toUpperCase() +
					this.resolvedAddress.City.substr(1).toLowerCase()
				);
			} else {
				return '';
			}
		},
	},
	methods: {
		checkPostalCode() {
			// if (!this.autoJumpPc) {
			// 	return;
			// }
			if (this.address.Postalcode.length === 7) {
				this.$refs.houseNumberInput.focus();
			}
		},
	},
	data() {
		return {
			changeAddress: false,
			// eslint-disable-next-line
			autoJumpPc: APP_AUTOJUMPPC,
		};
	},
};
</script>

<style></style>
